module.exports = __webpack_public_path__ + "img/multi-7.cdf8394f.svg";